<template>
  <section class="section content-container">
    <n-loading-spinner v-if="isLoading" />
    <div class="container is-fluid" v-show="!isLoading">
      <div class="island">
        <nav class="level">
          <div class="level-left"></div>
          <div class="level-right">
            <p class="level-item">
              <n-button variant="primary" @click="showCreateModal = true">Create Workspace</n-button>
            </p>
          </div>
        </nav>

        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>Name</th>
              <th>&nbsp;</th>
              <th class="has-text-centered" style="width: 150px">Access Tenant</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="workspace in workspaces" :key="workspace.id">
              <td>
                <router-link :to="{ name: 'platform-admin-workspace-edit', params: { id: workspace.id } }">
                  {{ workspace.name }}
                </router-link>
              </td>
              <td>&nbsp;</td>
              <td class="has-text-centered">
                <n-button icon="skip-next" variant="action" @click="accessTenant(workspace)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  <CreateWorkspaceModal v-if="showCreateModal" @close="showCreateModal = false" @workspace-created="loadWorkspaces" />
</template>

<script lang="ts" setup>
import { CHANGE_WORKSPACE, HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { onBeforeMount, ref } from 'vue';
import { workspacesApi } from '@/workspaces/workspaces';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import { store } from '@/store';
import CreateWorkspaceModal from '@/features/platformAdmin/workspaces/CreateWorkspaceModal.vue';
import NButton from '@shared/designsystem/components/control/button/button.vue';
import router from '@/router';

const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);
const workspaces = ref<WorkspaceViewModel[]>([]);
const isLoading = ref(false);
const showCreateModal = ref(false);

onBeforeMount(async () => {
  await loadWorkspaces();
});

async function loadWorkspaces() {
  isLoading.value = true;
  showCreateModal.value = false;

  try {
    workspaces.value = await workspacesApi.loadAll(true);
  } catch (err: any) {
    await handleSeriousError(err.message);
  } finally {
    isLoading.value = false;
  }
}

async function accessTenant(workspace: WorkspaceViewModel) {
  await store.dispatch(CHANGE_WORKSPACE, workspace);
  await router.push({ name: 'root' });
}
</script>
